export const Characters = {
  phoneNumber: [' ', '(', ')', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-', '/'],
  number: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'],
  float: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.']
};

export const useAllowCharacters = (
  allowed: string[]
): ((e: React.KeyboardEvent<HTMLInputElement>) => void) => {
  const handleKeyDownCharacters = (e: React.KeyboardEvent<HTMLInputElement>): void => {
    const value = e.key;
    const charCode = String.fromCharCode(e.which).toLowerCase();
    const ctrlCondition =
      ((e.ctrlKey || e.metaKey) && charCode === 's') || charCode === 'c' || charCode === 'v';

    if (
      e.key !== 'Backspace' &&
      e.key !== 'Clear' &&
      e.key !== 'Copy' &&
      e.key !== 'CrSel' &&
      e.key !== 'Cut' &&
      e.key !== 'Delete' &&
      e.key !== 'EraseEof' &&
      e.key !== 'ExSel' &&
      e.key !== 'ExSel' &&
      e.key !== 'Insert' &&
      e.key !== 'Paste' &&
      e.key !== 'Redo' &&
      e.key !== 'Enter' &&
      e.key !== 'Tab' &&
      e.key !== 'Undo' &&
      e.key !== 'ArrowLeft' &&
      e.key !== 'ArrowRight' &&
      e.key !== 'Home' &&
      e.key !== 'End' &&
      ctrlCondition === false &&
      allowed.includes(value) === false
    ) {
      e.preventDefault();
    }
  };

  return handleKeyDownCharacters;
};

export const useUnformatValue = (allowed: string[]): ((currentString: string) => string) => {
  const unformatValue = (currentString: string): string => {
    let unformatString = '';
    Array.from(currentString).forEach((character) => {
      if (allowed.includes(character)) {
        unformatString += character;
      }
    });
    return unformatString;
  };
  return unformatValue;
};
